import { Lesson } from '../../api/types/lesson';
import { ContentInsights, CustomContentInsight, getCustomContentInsight } from './types';
import { ContentGroup } from '../../api/types/contentGroup';
import { Goal } from '../../api/types/contentManagement';
import { getPossibleCategories } from '../../api/contentManagement/utils';

const getCategoryInsightText = (category?: string, pillar?: string, categories?: string[], goals?: Goal[]) => {
  if (!category) {
    return undefined;
  }
  if (!!categories && categories?.length > 0 && !categories.includes(category)) {
    return ContentInsights.invalidCategory;
  }
  if (!!pillar && !!goals && goals?.length > 0) {
    const possibleCategories = getPossibleCategories(goals, pillar);
    if (!possibleCategories.includes(category)) {
      return ContentInsights.incompatibleCategory;
    }
  }
  return undefined;
};

export const getInsights = (
  content: Lesson | ContentGroup,
  contentType: 'lesson' | 'contentGroup',
  categories?: string[],
  goals?: Goal[],
) => {
  const insights: CustomContentInsight[] = [];
  if (!content?.pillarType) {
    insights.push(getCustomContentInsight('pillarType', ContentInsights.missingPillarType));
  }
  if (!content?.pillarExpertise) {
    insights.push(getCustomContentInsight('pillarExpertise', ContentInsights.missingPillarExpertise));
  }
  if (!content?.category) {
    insights.push(getCustomContentInsight('category', ContentInsights.missingCategory));
  }
  if (!content?.imagePath) {
    insights.push(getCustomContentInsight('imagePath', ContentInsights.missingImage));
  }

  const categoryInsightText = getCategoryInsightText(content?.category, content?.pillarType, categories, goals);
  if (!!categoryInsightText) {
    insights.push(getCustomContentInsight('category', categoryInsightText));
  }

  if (contentType === 'lesson') {
    const lesson = content as Lesson;
    if (!lesson?.keyTakeaways || (Array.isArray(lesson?.keyTakeaways) && lesson?.keyTakeaways?.length === 0)) {
      insights.push(getCustomContentInsight('keyTakeaways', ContentInsights.missingKeyTakeaways));
    }
    if (lesson?.isRagsToRichesStory) {
      insights.push(getCustomContentInsight(null, ContentInsights.migratedRagsToRichesStory));
    }
    if (lesson?.isSleepStory) {
      insights.push(getCustomContentInsight(null, ContentInsights.migratedSleepStory));
    }
    if (lesson?.isSpecialStory) {
      insights.push(getCustomContentInsight(null, ContentInsights.migratedSpecialStory));
    }
    if (lesson?.isWisdomStory) {
      insights.push(getCustomContentInsight(null, ContentInsights.migratedWisdomStory));
    }
  }

  if (contentType === 'contentGroup') {
    const contentGroup = content as ContentGroup;
    if (!!contentGroup?.packId) {
      insights.push(getCustomContentInsight(null, ContentInsights.migratedPack));
    }
    if (contentGroup?.removeFromSale) {
      insights.push(getCustomContentInsight('removeFromSale', ContentInsights.removeFromSale));
    }
    if (contentGroup?.isTestingGroup) {
      insights.push(getCustomContentInsight('isTestingGroup', ContentInsights.isTestingGroup));
    }
  }

  return insights;
};
